export default __webpack_public_path__ + "static/media/client3.803c680f.png";